var exports = {
  "kL": "ChannelAnnouncementBanner.module__container___X3g2QV",
  "fW": "ChannelAnnouncementBanner.module__collapsedBar___X3g2QV",
  "FB": "ChannelAnnouncementBanner.module__collapsedLeft___X3g2QV",
  "r$": "ChannelAnnouncementBanner.module__pillBadge___X3g2QV",
  "Wi": "ChannelAnnouncementBanner.module__previewText___X3g2QV",
  "cx": "ChannelAnnouncementBanner.module__collapsedRight___X3g2QV",
  "IO": "ChannelAnnouncementBanner.module__expandedCard___X3g2QV",
  "MY": "ChannelAnnouncementBanner.module__cardHeader___X3g2QV",
  "$2": "ChannelAnnouncementBanner.module__cardHeaderLeft___X3g2QV",
  "JJ": "ChannelAnnouncementBanner.module__cardTitle___X3g2QV",
  "Iq": "ChannelAnnouncementBanner.module__authorTag___X3g2QV",
  "eB": "ChannelAnnouncementBanner.module__cardActions___X3g2QV",
  "hP": "ChannelAnnouncementBanner.module__actionButton___X3g2QV",
  "zI": "ChannelAnnouncementBanner.module__cardBody___X3g2QV",
  "Ef": "ChannelAnnouncementBanner.module__editContainer___X3g2QV",
  "Vz": "ChannelAnnouncementBanner.module__editTextarea___X3g2QV",
  "uK": "ChannelAnnouncementBanner.module__editActionsRow___X3g2QV",
  "tB": "ChannelAnnouncementBanner.module__btnPrimary___X3g2QV",
  "zq": "ChannelAnnouncementBanner.module__btnSecondary___X3g2QV",
};

module.exports = exports;
